import * as Util from "../Utils/Util";
import Events from "../Utils/Events";
import ProductState from "./ProductState";
import { Discount } from "./ProductPageStateSchema";
import Hider from "../Utils/Hider";

export class DiscountElementSwitcher {
  private readonly noDiscountElement: HTMLElement;
  private readonly discountElement: HTMLElement;
  private readonly discountAmounts: HTMLElement[];

  public constructor(element: HTMLElement) {
    this.noDiscountElement = Util.findByBindName("no-discount", element) as HTMLElement;
    this.discountElement = Util.findByBindName("has-discount", element) as HTMLElement;

    DiscountElementSwitcher.alterDiscountElement(this.discountElement);
    const discountAmountsNodeList = Util.findByBindNameAll("discount-element-switcher-amount", this.discountElement);
    this.discountAmounts = Array.from(discountAmountsNodeList).map((n) => n as HTMLElement);

    Events.on("product-state-change", (s: ProductState) => this.swapElements(s));
  }

  private static alterDiscountElement(discountElement: HTMLElement): void {
    const innerHTML = discountElement.innerHTML;
    const replacementHTML = innerHTML.replace(
      "{{discountAmount}}",
      "<span data-js-bind='discount-element-switcher-amount'></span>"
    );
    discountElement.innerHTML = replacementHTML;
  }

  private swapElements(s: ProductState): void {
    const discount: Discount | null = s.quantity.discount;

    if (discount == null || discount.discountSaving == null) {
      Hider.hide(this.discountElement, true);
      Hider.show(this.noDiscountElement, true);
      return;
    }

    console.log(this.discountElement);

    this.discountAmounts.forEach((e) => {
      e.innerText = discount.discountSaving;
    });

    console.log(this.discountElement);

    Hider.show(this.discountElement, true);
    Hider.hide(this.noDiscountElement, true);
  }
}

export default function bindDiscountElementSwitchers(): void {
  const modals = Util.findByBindNameAll("discount-element-switcher");
  modals.forEach((s) => new DiscountElementSwitcher(s as HTMLElement));
}
